export default "__VITE_ASSET__Bw14p80R__"